import React from "react";
import { Container, Skeleton } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import styles from "../GuidesTable/guidesTableStyles.js";
import NoData from "../../../components/SharedComponents/NoData";

const GuidesIncidenceTable = ({ guides = [], isLoading, search = "" }) => {
  const columns = [
    {
      field: "id",
      headerName: "ID",
      minWidth: 50,
      flex: 1,
      resizable: false,
      sortable: false,
      renderHeader: (params) => <strong>ID</strong>,
    },
    {
      field: "tracking_code",
      headerName: "CÓDIGO",
      minWidth: 120,
      flex: 1,
      resizable: false,
      sortable: false,
      renderHeader: (params) => <strong>CÓDIGO</strong>,
    },
    {
      field: "area",
      headerName: "AREA",
      type: "string",
      minWidth: 70,
      flex: 1,
      resizable: false,
      sortable: false,
      headerAlign: "left",
      align: "left",
      renderHeader: (params) => <strong>AREA</strong>,
    },
    {
      field: "zone",
      headerName: "ZONA",
      type: "string",
      minWidth: 70,
      flex: 1,
      resizable: false,
      sortable: false,
      headerAlign: "left",
      align: "left",
      renderHeader: (params) => <strong>ZONA</strong>,
    },
    {
      field: "sector",
      headerName: "SECTOR",
      type: "string",
      minWidth: 90,
      flex: 1,
      resizable: false,
      sortable: false,
      headerAlign: "left",
      align: "left",
      renderHeader: (params) => <strong>SECTOR</strong>,
    },
    {
      field: "subsector",
      headerName: "SUB",
      type: "string",
      minWidth: 110,
      flex: 1,
      resizable: false,
      sortable: false,
      headerAlign: "left",
      align: "left",
      renderHeader: (params) => <strong>SUB</strong>,
    },
    {
      field: "package_weight",
      headerName: "PESO",
      type: "string",
      minWidth: 60,
      flex: 1,
      resizable: false,
      sortable: false,
      headerAlign: "left",
      align: "left",
      renderHeader: (params) => <strong>PESO</strong>,
    },
    {
      field: "incidence_reason",
      headerName: "MOTIVO",
      type: "string",
      minWidth: 160,
      flex: 1,
      resizable: false,
      sortable: false,
      headerAlign: "left",
      align: "left",
      renderHeader: (params) => <strong>MOTIVO</strong>,
    },
    {
      field: "incidence_date",
      headerName: "FECHA",
      type: "string",
      minWidth: 120,
      flex: 1,
      resizable: false,
      sortable: false,
      headerAlign: "left",
      align: "left",
      renderHeader: (params) => <strong>FECHA</strong>,
    },
  ];

  const filteredRows = guides.filter((guide) => {
    const transformedUser = {
      ...guide,
    };

    return Object.values(transformedUser).some((value) =>
      value.toString().toLowerCase().includes(search.toLowerCase()),
    );
  });

  const rows = filteredRows?.map((guide) => ({
    id: guide.id_guide,
    tracking_code: guide.tracking_code,
    zone: guide.zone,
    area: guide.area,
    sector: guide.sector,
    subsector: guide.subsector,
    package_weight: guide.package_weight,
    incidence_reason: guide.incidence_reason || "—",
    incidence_date: guide.incidence_date || "—",
  }));

  return (
    <Container sx={styles.mainContainer}>
      {isLoading ? (
        <Container sx={styles.skeletonMainContainer}>
          <Container sx={styles.skeletonSecondaryContainer}>
            <Skeleton variant="rounded" width={"5%"} height={40} />
            <Skeleton variant="rounded" width={"10%"} height={40} />
            <Skeleton variant="rounded" width={"20%"} height={40} />
            <Skeleton variant="rounded" width={"10%"} height={40} />
            <Skeleton variant="rounded" width={"10%"} height={40} />
            <Skeleton variant="rounded" width={"10%"} height={40} />
            <Skeleton variant="rounded" width={"15%"} height={40} />
            <Skeleton variant="rounded" width={"15%"} height={40} />
          </Container>
          <Container sx={styles.skeletonSecondaryContainer}>
            <Skeleton variant="rounded" width={"5%"} height={300} />
            <Skeleton variant="rounded" width={"10%"} height={300} />
            <Skeleton variant="rounded" width={"20%"} height={300} />
            <Skeleton variant="rounded" width={"10%"} height={300} />
            <Skeleton variant="rounded" width={"10%"} height={300} />
            <Skeleton variant="rounded" width={"10%"} height={300} />
            <Skeleton variant="rounded" width={"15%"} height={300} />
            <Skeleton variant="rounded" width={"15%"} height={300} />
          </Container>
        </Container>
      ) : (
        <DataGrid
          autoHeight
          disableColumnFilter
          rows={rows}
          columns={columns}
          initialState={{
            pagination: {
              paginationModel: { page: 0, pageSize: 10 },
            },
          }}
          pageSizeOptions={[10, 20, 50, 100]}
          disableColumnMenu={true}
          disableSelectionOnClick={true}
          localeText={{
            noRowsLabel: (
              <NoData title="No se encontraron guías con incidencia" />
            ),
          }}
          sx={{
            "&.MuiDataGrid-root--densityCompact .MuiDataGrid-cell": {
              py: "8px",
              display: "flex",
              alignItems: "center",
            },
            "&.MuiDataGrid-root--densityStandard .MuiDataGrid-cell": {
              py: "6px",
              display: "flex",
              alignItems: "center",
            },
            "&.MuiDataGrid-root--densityComfortable .MuiDataGrid-cell": {
              py: "22px",
              display: "flex",
              alignItems: "center",
            },
          }}
        />
      )}
    </Container>
  );
};

export default GuidesIncidenceTable;
